import { useCallback, useEffect } from 'react';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getMessage } from '@gef-ui/localization/messages';
import ArrowRight from '@gef-ui/material-icons/ArrowRight';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { gtmDashboardSectionNames } from 'features/views/dashboard/constants';
import { useDetailButtonClickDataLayer } from 'features/views/dashboard/hooks';
import { fetchTasksAndInformation } from 'features/views/dashboard/tasksAndInformation/actions';

import TableOverview from './components/TableOverview';
import TimeStatusOverview from './components/TimeStatusOverview';

export const TasksAndInformation = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const pushToClickDetailButtonDataLayer = useDetailButtonClickDataLayer();

	useEffect(() => {
		dispatch(fetchTasksAndInformation());
	}, [dispatch]);

	const handleRedirect = useCallback(() => {
		pushToClickDetailButtonDataLayer({
			value: gtmDashboardSectionNames.TASKS,
		})();
		navigate('/tasks');
	}, [navigate, pushToClickDetailButtonDataLayer]);

	return (
		<Paper sx={{ p: 2, borderRadius: 1 }}>
			<Stack spacing={2}>
				<Stack
					direction="row"
					sx={{
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
				>
					<Typography sx={{ fontWeight: 'bold' }} variant="body1">
						{getMessage('dashboard:tasksAndInformation.title')}
					</Typography>
					<Button
						sx={{ width: 'max-content', justifyContent: 'left' }}
						variant="text"
						endIcon={<ArrowRight />}
						onClick={handleRedirect}
					>
						{getMessage('dashboard:detail')}
					</Button>
				</Stack>
				<ComponentLoader fetchStorePath={fetch.constants.urls.tasksAndInformation} forceInlineError>
					<Paper
						sx={{
							px: 3,
							py: 2,
							backgroundColor: (theme) => theme.palette.background[100],
							borderRadius: 1,
						}}
					>
						<Stack spacing={3}>
							<TimeStatusOverview />
							<TableOverview />
						</Stack>
					</Paper>
				</ComponentLoader>
			</Stack>
		</Paper>
	);
};

export default TasksAndInformation;
